function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n  .wel-scb0{fill:#F7FBFE;}\n  .wel-scb1{fill:none;}\n  .wel-scb2{fill:#7BA2C1;}\n  .wel-scb3{fill:#E5EBF0;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "wel-scb0",
  d: "M249.3,60.2c-8.9-8.9-23.4-8.9-32.4,0l-4.9,4.9L153.7,6.7C149.2,2.2,143.4,0,137.5,0c-5.9,0-11.7,2.2-16.2,6.7     L28.7,99.4c-8.9,8.9-8.9,23.5,0,32.4c8.9,8.9,23.4,8.9,32.4,0l4.9-4.9l58.3,58.4c0,0,0,0,0,0c4.5,4.5,10.3,6.7,16.2,6.7     c5.9,0,11.7-2.2,16.2-6.7l71.5-71.6c0,0,0,0,0,0l21.1-21.1C258.2,83.6,258.2,69.1,249.3,60.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "wel-scb0",
  d: "M40.5,63.5c-4.7-4.7-12.3-4.7-17.1,0L3.5,83.4c-4.7,4.7-4.7,12.3,0,17.1c4.7,4.7,12.3,4.7,17.1,0l19.9-19.9     C45.2,75.9,45.2,68.2,40.5,63.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "wel-scb0",
  d: "M191.4,157.5l-19.9,19.9c-4.7,4.7-4.7,12.3,0,17.1c4.7,4.7,12.3,4.7,17.1,0l19.9-19.9c4.7-4.7,4.7-12.3,0-17.1     C203.8,152.8,196.1,152.8,191.4,157.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "wel-scb0",
  d: "M221.7,46.4l12.8-12.8c4.7-4.7,4.7-12.4,0-17.1c-4.7-4.7-12.4-4.7-17.1,0l-12.8,12.8c-4.7,4.7-4.7,12.4,0,17.1     C209.3,51.2,216.9,51.2,221.7,46.4z"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "wel-scb1",
  d: "M153.7,39.1l-92.6,92.7c-8.9,8.9-23.4,8.9-32.4,0c-8.9-8.9-8.9-23.5,0-32.4l92.6-92.7c8.9-8.9,23.4-8.9,32.4,0   C162.6,15.6,162.6,30.1,153.7,39.1L153.7,39.1z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "wel-scb1",
  d: "M249.3,92.6l-92.6,92.7c-8.9,8.9-23.4,8.9-32.4,0c-8.9-8.9-8.9-23.5,0-32.4l92.6-92.7c8.9-8.9,23.4-8.9,32.4,0   C258.2,69.1,258.2,83.6,249.3,92.6L249.3,92.6z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "wel-scb1",
  d: "M228.2,113.7l-71.5,71.6c-8.9,8.9-23.4,8.9-32.4,0l-74.5-74.6c-8.9-8.9-8.9-23.5,0-32.4l71.5-71.6   c8.9-8.9,23.4-8.9,32.4,0l74.5,74.6C237.2,90.2,237.2,104.7,228.2,113.7L228.2,113.7z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "wel-scb1",
  d: "M40.5,80.6l-19.9,19.9c-4.7,4.7-12.3,4.7-17.1,0c-4.7-4.7-4.7-12.3,0-17.1l19.9-19.9c4.7-4.7,12.3-4.7,17.1,0   C45.2,68.2,45.2,75.9,40.5,80.6L40.5,80.6z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "wel-scb1",
  d: "M208.5,174.6l-19.9,19.9c-4.7,4.7-12.3,4.7-17.1,0c-4.7-4.7-4.7-12.3,0-17.1l19.9-19.9c4.7-4.7,12.3-4.7,17.1,0   C213.2,162.2,213.2,169.9,208.5,174.6L208.5,174.6z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "wel-scb1",
  d: "M234.5,33.6l-12.8,12.8c-4.7,4.7-12.4,4.7-17.1,0c-4.7-4.7-4.7-12.4,0-17.1l12.8-12.8c4.7-4.7,12.4-4.7,17.1,0   C239.2,21.3,239.2,28.9,234.5,33.6L234.5,33.6z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "wel-scb2",
  d: "M169,139v-0.4V139C169.1,139,169,139,169,139L169,139L169,139z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "wel-scb2",
  d: "M169,138.6l-0.5-3.5c0.2,0,0.3,0,0.5,0V138.6L169,138.6L169,138.6z"
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  className: "wel-scb2",
  points: "113,139 113,135 113,139 113.5,135 113,139 "
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "wel-scb1",
  d: "M94.5,89.4c-0.7,0.8-1.8,0.8-2.5,0L80.8,76.5c-0.7-0.8-0.7-2.1,0-2.9s1.8-0.8,2.5,0l11.2,12.9   C95.2,87.3,95.2,88.6,94.5,89.4L94.5,89.4z M83.3,76.5L72.1,89.4c-0.7,0.8-1.8,0.8-2.5,0c-0.7-0.8-0.7-2.1,0-2.9l11.2-12.9   c0.7-0.8,1.8-0.8,2.5,0S84,75.7,83.3,76.5L83.3,76.5z M82.1,105L82.1,105c-1.1,0-2-0.9-2-2V77c0-1.1,0.9-2,2-2h0.1c1.1,0,2,0.9,2,2   V103C84,104.1,83.2,105,82.1,105L82.1,105z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "wel-scb3",
  d: "M94.5,86.5L83.3,73.6c0,0,0,0,0,0C82.9,73.2,82.5,73,82,73c-0.5,0-0.9,0.2-1.2,0.6c0,0,0,0,0,0L69.6,86.5   c-0.7,0.8-0.7,2.1,0,2.9c0.7,0.8,1.8,0.8,2.5,0l8-9.2V103c0,1.1,0.9,2,2,2h0.1c1.1,0,2-0.9,2-2V80.2l8,9.2c0.7,0.8,1.8,0.8,2.5,0   C95.2,88.6,95.2,87.3,94.5,86.5z"
});

var _ref15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "wel-scb2",
  d: "M174,94.4c-0.3-6.9-2.8-13.3-6.7-18.5c-0.7-0.9-1.9-1-2.8-0.4c-0.9,0.7-1,1.9-0.4,2.8     c3.6,4.7,5.7,10.3,5.9,16.2l0.1,3.1l3.1,0.6c8.6,1.7,14.8,9.4,14.8,18.1c0,10.2-8.3,18.5-18.5,18.5l-0.3,0l-0.1,0l-0.1,0l-0.2,0     l0,0h-55.6c0,0-0.1,0-0.1,0l-0.1,0l-0.1,0l-0.3,0c-10.2,0-18.5-8.3-18.5-18.5c0-8.8,6.2-16.4,14.8-18.1l3.1-0.6l0.1-3.1     c0.7-15.5,13.4-27.6,29-27.6c4.4,0,8.5,0.9,12.4,2.8c1,0.5,2.2,0.1,2.7-0.9c0.5-1,0.1-2.2-0.9-2.7c-4.3-2-9.1-3.2-14.2-3.2     c-17.7,0-32.1,13.9-33,31.4c-10.3,2.1-18,11.2-18,22.1c0,12.4,10.1,22.5,22.7,22.5c0.1,0,0.1,0,0.2,0c0,0,0,0,0.1,0l0.1-0.4v0.5h56     v-0.8l0.1,0.8c0.1,0,0.1,0,0.4,0c12.4,0,22.5-10.1,22.5-22.5C192,105.6,184.3,96.5,174,94.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "wel-scb2",
  d: "M150.9,95.4c0-5.8-4.7-10.4-10.4-10.4s-10.4,4.7-10.4,10.4c0,5.8,4.7,10.4,10.4,10.4     C146.3,105.8,150.9,101.2,150.9,95.4z M134.1,95.4c0-3.5,2.9-6.4,6.4-6.4c3.5,0,6.4,2.9,6.4,6.4c0,3.5-2.9,6.4-6.4,6.4     C137,101.8,134.1,99,134.1,95.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "wel-scb2",
  d: "M122,118c-0.6,0.9-0.3,2.2,0.7,2.8c0.9,0.6,2.2,0.3,2.8-0.7c3.3-5.3,8.9-8.5,15.1-8.5c6.2,0,11.8,3.2,15.1,8.5     c0.6,0.9,1.8,1.2,2.8,0.7c0.9-0.6,1.2-1.8,0.7-2.8c-3.8-6.2-10.7-10.4-18.5-10.4C132.7,107.6,125.8,111.8,122,118z"
}), /*#__PURE__*/React.createElement("path", {
  className: "wel-scb2",
  d: "M150.1,59.4l8-9.2V80c0,1.1,0.9,2,2,2h0.1c1.1,0,2-0.9,2-2V50.2l8,9.2c0.7,0.8,1.8,0.8,2.5,0     c0.7-0.8,0.7-2.1,0-2.9l-11.2-12.9c-0.7-0.8-1.8-0.8-2.5,0c0,0,0,0,0,0c0,0,0,0,0,0l-11.2,12.9c-0.7,0.8-0.7,2.1,0,2.9     C148.3,60.2,149.4,60.2,150.1,59.4z"
}));

var SvgStartBackup = function SvgStartBackup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 198",
    style: {
      enableBackground: "new 0 0 256 198"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStartBackup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/start_backup.402e548c.svg";
export { ForwardRef as ReactComponent };